import { toast } from "react-toastify";

export function GetIndividualBonusMkt(totalVendido, metas) {
  try {
    if (!Array.isArray(metas) || metas.length === 0) return 0;

    // Encontrar la meta más alta alcanzada
    const metaCumplida = metas
      .filter((m) => totalVendido >= m.meta)
      .sort((a, b) => b.meta - a.meta)[0];

    if (!metaCumplida) return 0;

    const porcentaje = metaCumplida.metaPorcentaje || 0;
    const bono = (porcentaje / 100) * metaCumplida.meta;

    return bono;
  } catch (e) {
    toast.error("Error calculando el bono individual: " + e);
    return 0;
  }
}
